<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
          @titleClick='onSelectedVendor'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.거래처명}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>
    <PurchaseInputPivotComponent ref='refPurchaseInputPivotComponent' @refresh-input-vendor-list="refreshInputVendorList"
      pType='S0106' materialType='S0402' :company="this.company"/>
  </div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxTabPanel from 'devextreme-vue/tab-panel'
import PurchaseInputPivotComponent from './PurchaseInputPivotComponent'
import AppLib from '../../share/AppLib'

export default {
  name: 'RawMaterialPivotTab',
  data: function () {
    return {
      selectedIndex: 0,
      tabs: [
        {
          title: '원자재구매내역'
        }
      ],
      company: 'ALL'
    }
  },
  components: {
    DxTabPanel,
    PurchaseInputPivotComponent
  },
  created () {
    document.title = ConstDef.TAB_TITLE
    let user = this.$store.getters.getUserInfo
    if (user === undefined || user === null) {
      this.$router.push('/')
    }
    this.refreshInputVendorList(`${AppLib.getThisYear()}-${AppLib.getThisMonth()}`)
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {
    this.$store.commit('deleteInoutList')
  },
  methods: {
    onSelectedVendor () {
      this.selectedVendor = this.tabs[this.selectedIndex].입고업체
      this.company = this.tabs[this.selectedIndex].거래처명
      this.$refs.refPurchaseInputPivotComponent.refreshDataGridFromParent(this.selectedVendor)
    },
    refreshInputVendorList (date) {
      const param = {
        toDate: `${date}-${AppLib.getMonthLastDay(date.split('-')[0], date.split('-')[1])} 23:59:59`,
        fromDate: `${date}-01`,
        자재유형: ConstDef.자재유형_원자재,
        입출고구분: ConstDef.자재입고
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInputVendorList', param)
        .then((data) => {
          this.tabs = this.$_sp.MakeModel(data)
          this.tabs.unshift({ 거래처명: 'ALL', 입고업체: 'ALL' })
          this.selectedVendor = this.tabs[0].입고업체
          this.selectedIndex = 0
          console.log(this.selectedVendor)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
